import type { DataFrame } from 'src/services/websocket/ws-protocol';

type IsLiveListener = () => void;
type FrameListener = (frame: DataFrame) => void;

let isLive = false;
const isLiveListeners = new Set<IsLiveListener>();
const frameListeners = new Set<FrameListener>();

export function getIsLive(): boolean {
    return isLive;
}

export function setLive(next: boolean): void {
    if (next === isLive) {
        return;
    }

    isLive = next;
    isLiveListeners.forEach((listener) => listener());
}

export function subscribeIsLive(listener: IsLiveListener): () => void {
    isLiveListeners.add(listener);
    return () => isLiveListeners.delete(listener);
}

export function subscribeToFrames(listener: FrameListener): () => void {
    frameListeners.add(listener);
    return () => frameListeners.delete(listener);
}

export function emitFrame(frame: DataFrame): void {
    frameListeners.forEach((listener) => listener(frame));
}
